import axios from '../../axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchGuestLoginsByContact({ commit, dispatch, getters }, id) {
      return new Promise((resolve, reject) => {
        const odata = '$select=id,fullName,userPic,userPitch,email';
        axios.get(`/core/guestlogins/contact/${id}`, {
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    addNewGuestLogin({ commit, dispatch, getters }, newGuestLogin) {
      return new Promise((resolve, reject) => {
        axios.post('/core/guestlogins/profile', newGuestLogin).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    archiveGuestLogin({ commit, dispatch, getters }, guestLoginId) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/guestlogins/${guestLoginId}/archive`).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    updateGuestLogin({ commit, dispatch, getters }, guestLogin) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/guestlogins/${guestLogin.id}/profile`, guestLogin).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

  },
};
